import { render, staticRenderFns } from "./skillTables.vue?vue&type=template&id=49bc61bd&scoped=true"
import script from "./skillTables.vue?vue&type=script&lang=js"
export * from "./skillTables.vue?vue&type=script&lang=js"
import style0 from "./skillTables.vue?vue&type=style&index=0&id=49bc61bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bc61bd",
  null
  
)

export default component.exports